export default __webpack_public_path__ + "static/media/a1.585e9816.png";